import WifiOffIcon from '@mui/icons-material/WifiOff';
import { Box, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useOnlineStatus } from '@shared/hooks/useOnlineStatus';
import React from 'react';

const OFFLINE_DIALOG_Z_INDEX = 10_100;

const TITLE = 'Sin conexión a internet';
const MESSAGE =
  'Necesitas estar conectado a internet para continuar. Revisa tu conexión — esta ventana se cerrará cuando se restablezca la conexión.';

const OfflineBlockerDialog: React.FC = () => {
  const { isOnline } = useOnlineStatus();

  return (
    <Dialog
      open={!isOnline}
      disableEscapeKeyDown
      onClose={(_event, reason) => {
        if (reason === 'backdropClick') return;
      }}
      maxWidth="sm"
      fullWidth
      aria-labelledby="offline-blocker-title"
      sx={{ zIndex: OFFLINE_DIALOG_Z_INDEX }}
      slotProps={{
        root: { sx: { zIndex: OFFLINE_DIALOG_Z_INDEX } },
        paper: { sx: { borderRadius: '16px' } },
      }}>
      <DialogTitle id="offline-blocker-title" sx={{ fontWeight: 700, fontSize: '22px', pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <WifiOffIcon color="error" sx={{ fontSize: 32 }} />
          {TITLE}
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pb: 3 }}>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          {MESSAGE}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default OfflineBlockerDialog;
